import { render, staticRenderFns } from "./Dresses.vue?vue&type=template&id=0ab51e1a"
import script from "./Dresses.vue?vue&type=script&lang=js"
export * from "./Dresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports